import {
  EVENT_ADD_CONTACTS,
  EVENT_CLEAR_CONTACTS,
  EVENT_EDIT_CONTACT,
  EVENT_REMOVE_CONTACTS,
  EventAddContactsPayload,
  EventEditContactPayload,
  EventRemoveContactsPayload,
} from '@weblite/ts-action/contact'
import { serverSub } from '$func/subscription'
import { saveContacts } from '$logic/contacts/service'
import { contactsStorage } from '$logic/contacts/storage'

serverSub.subscribe(
  EVENT_ADD_CONTACTS,
  ({ contacts }: EventAddContactsPayload) => {
    saveContacts(contacts)
  },
)

serverSub.subscribe(
  EVENT_EDIT_CONTACT,
  async ({ phone, ...contact }: EventEditContactPayload) => {
    const { id } = (await contactsStorage.findByPhone(phone)) || {}
    if (id) contactsStorage.set(id, contact)
  },
)

serverSub.subscribe(
  EVENT_REMOVE_CONTACTS,
  ({ phones }: EventRemoveContactsPayload) => {
    contactsStorage.deleteByPhones(phones)
  },
)

serverSub.subscribe(EVENT_CLEAR_CONTACTS, () => {
  contactsStorage.deleteAll()
})
